// extracted by mini-css-extract-plugin
export default {"root":"RecurringInvoices_root__4eUX2","header":"RecurringInvoices_header__JtLZU"};